import { useRef, useState, useEffect } from 'react';
import { useFilter } from '../../contexts/FilterContext';

const SearchBar = () => {
    const { selectedFilters, setSelectedFilters, searchQuery } = useFilter();

    const [searchText, setSearchText] = useState(() => {
        return searchQuery || '';
    });

    const inputRef = useRef(null);
    const lastExecutedSearchRef = useRef(searchQuery || '');

    // Only sync when search is cleared externally AND it was previously executed
    useEffect(() => {
        if (selectedFilters?.search === '' &&
            lastExecutedSearchRef.current !== '' &&
            searchText !== '') {
            setSearchText('');
            lastExecutedSearchRef.current = '';
        }
    }, [selectedFilters?.search, searchText]);

    // Execute search (for Go button and Enter key)
    const executeSearch = () => {
        // Track the executed search
        lastExecutedSearchRef.current = searchText;

        // Update search filter
        setSelectedFilters(prevFilters => ({
            ...prevFilters,
            search: searchText
        }));
    };

    // Handle form submission (Enter key)
    const handleSubmit = (e) => {
        e.preventDefault();
        executeSearch();
    };

    // Handle key down events
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            executeSearch();
        }
    };

    return (
        <form onSubmit={handleSubmit} className='headless-searchbar'>
            <input
                ref={inputRef}
                placeholder='Search...'
                name='filter-search-input'
                className='headless-nav-searchbar-input'
                type='text'
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={handleKeyDown}
                aria-label='Search for products'
            />
            {searchText && (
                <>
                    <button
                        type='button'
                        className='search-go-button'
                        onClick={executeSearch}
                        aria-label='Execute search'
                    >
                        Go
                    </button>
                </>
            )}
        </form>
    );
};

export default SearchBar;
